import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '@ui/button';
import { Heading } from '@web/atoms';
import { IMAGE_SIZES, ResponsiveImage, CtaShell } from '@web/molecules';
import {
  ButtonContainer,
  Subtext,
  TestimonialContainer,
  TestimonialsHighlightContainer,
  ButtonWrapper,
} from './styles';

export const TestimonialHighlight = ({
  testimonial,
  image,
  buttonText,
  buttonTarget,
  backgroundColor,
  alignment = 'center',
}) => {
  return (
    <TestimonialsHighlightContainer backgroundColor={backgroundColor}>
      {image?.src && <ResponsiveImage {...image} sizes={IMAGE_SIZES.half} />}
      <TestimonialContainer>
        <Heading
          headingLevel="h5"
          headingText={testimonial.body}
          position="center"
          typography="heading4"
          verticalPadding={1}
          backgroundColor="background.base"
        />
        <Subtext>{testimonial.name}</Subtext>
        <ButtonContainer $alignment={alignment}>
          <ButtonWrapper backgroundColor={backgroundColor}>
            <CtaShell alignment={alignment}>
              <LinkButton
                href={buttonTarget}
                alignment={alignment}
                horizontalPadding={10}
              >
                {buttonText}
              </LinkButton>
            </CtaShell>
          </ButtonWrapper>
        </ButtonContainer>
      </TestimonialContainer>
    </TestimonialsHighlightContainer>
  );
};

TestimonialHighlight.displayName = 'TestimonialHighlight';

TestimonialHighlight.propTypes = {
  image: PropTypes.object,
  backgroundColor: PropTypes.string,
  buttonTarget: PropTypes.string.isRequired,
  testimonial: PropTypes.object.isRequired,
  buttonText: PropTypes.string.isRequired,
  alignment: PropTypes.oneOf(['left', 'center', 'right']),
};
